import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import AppLabelWithValue from 'src/components/appComponents/AppLabelWithValue';
import Label from 'src/components/label';
import { useBoolean } from 'src/hooks/use-boolean';
import { Dialog, DialogContent, Link } from '@mui/material';
import ReactPlayer from 'react-player/youtube';

type Props = {
  suggestion: any;
  type: string;
};

export default function ParentSuggestionsInfo({ suggestion, type }: Props) {
  const showVideo = useBoolean();

  return (
    <>
      <Grid item container mb={3} alignItems="center">
        <Grid item xs={6} md={2}>
          <Typography variant="h4" color="primary">
            Suggestion Info
          </Typography>
        </Grid>
        <Grid item xs={6} md={10}>
          <Label
            color={
              suggestion?.status == 'Pending'
                ? 'warning'
                : suggestion?.status == 'Approved'
                  ? 'success'
                  : suggestion?.status == 'Rejected'
                    ? 'error'
                    : 'default'
            }
          >
            {suggestion?.status}
          </Label>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container rowSpacing={3}>
          <AppLabelWithValue
            label={`${type}  ${type == 'Channel' ? 'Name' : 'Title'}`}
            value={suggestion?.title?.ar}
          />
          <AppLabelWithValue
            label={`English ${type} ${type == 'Channel' ? 'Name' : 'Title'}`}
            value={suggestion?.title?.en}
          />
          <AppLabelWithValue label={`${type} Description`} value={suggestion?.description?.ar} />
          <AppLabelWithValue
            label={`English ${type} Description`}
            value={suggestion?.description?.en}
          />
          <AppLabelWithValue label="Type" value={suggestion?.type} />
          <AppLabelWithValue
            label={`${type} Link`}
            value={
              type == 'Channel' ? (
                <Link href={suggestion?.link} target="_blank" rel="noopener">
                  Preview
                </Link>
              ) : (
                <Typography
                  sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                  fontWeight={500}
                  onClick={showVideo.onTrue}
                >
                  Preview
                </Typography>
              )
            }
          />
          <AppLabelWithValue
            label="Created"
            value={new Date(suggestion?.createdAt)?.toDateString()}
          />
        </Grid>
      </Grid>

      {/* Show Video Link */}
      {showVideo.value && (
        <Dialog maxWidth="md" open={showVideo.value} onClose={showVideo.onFalse}>
          <DialogContent sx={{ p: 0, overflow: 'hidden' }}>
            <ReactPlayer url={suggestion?.link} controls playing />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
